var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIc18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7213 5.33625C14.0133 5.04423 14.0133 4.57077 13.7213 4.27875C13.4292 3.98673 12.9558 3.98673 12.6638 4.27875L9.70711 7.23539C9.31658 7.62592 8.68342 7.62592 8.29289 7.23539L5.33625 4.27875C5.04423 3.98673 4.57077 3.98673 4.27875 4.27875C3.98673 4.57077 3.98673 5.04423 4.27875 5.33625L7.23539 8.29289C7.62592 8.68342 7.62592 9.31658 7.23539 9.70711L4.27875 12.6638C3.98673 12.9558 3.98673 13.4292 4.27875 13.7213C4.57077 14.0133 5.04423 14.0133 5.33625 13.7213L8.29289 10.7646C8.68342 10.3741 9.31658 10.3741 9.70711 10.7646L12.6638 13.7213C12.9558 14.0133 13.4292 14.0133 13.7213 13.7213C14.0133 13.4292 14.0133 12.9558 13.7213 12.6638L10.7646 9.70711C10.3741 9.31658 10.3741 8.68342 10.7646 8.29289L13.7213 5.33625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIc18);
export default __webpack_public_path__ + "static/media/close_ic_18.bd47578e0fdc10b77a181503b6920658.svg";
export { ForwardRef as ReactComponent };